import React, {useContext, useState} from "react";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {TrafficLightDeviceOverviewContext} from "../context/TrafficLightOverviewContext";
import {TRAFFIC_LIGHT_RESOURCE_TYPE} from "../../../util/Constants";

const AddTrafficLightDeviceModal = ({open, setOpen, controllerConfig, indexForControllerData}) => {
    const {dispatch} = useContext(TrafficLightDeviceOverviewContext);
    const [label, setLabel] = useState("")
    const [wave, setWave] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const addAsset = () => {
        let newAssetMapping = {
            "mappedResourceLabel": label,
            "mappedResourceType": TRAFFIC_LIGHT_RESOURCE_TYPE,
            "mappingAttributes": {
                "color": null,
                "wave": wave
            }
        }

        let newControllerConfig = {...controllerConfig};
        newControllerConfig["assetMappings"].push(newAssetMapping)
        dispatch({type: 'UPDATE_TRAFFIC_LIGHT_DEVICE_DATA', data: {dispatcher: dispatch, index: indexForControllerData, assetDetails: newControllerConfig}})
    }

    const onClickConfirm = () => {
            addAsset();
            resetInputState();
            setOpen(false);
    }

    function resetInputState() {
        resetAssetDetails();
    }

    const resetAssetDetails = () => {
        setLabel("");
        setWave(null)
    }

    return(
        <Modal
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="100%"
        >
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="name-input">
                        <FormattedMessage id="modal.name"
                                          defaultMessage="Device Name"/>
                    </Text>
                    <Input id="name-input"
                           value={label}
                           onChange={setLabel}
                           helperText={"Enter label of the device. e.g. \"L0-T1\""}
                    />
                </Column>
                <Column spacing="200">
                    <Text tag="label" type="b200" color="primary" htmlFor="wave-input">
                        <FormattedMessage id="modal.wave"
                                          defaultMessage="Wave Number"/>
                    </Text>
                    <Input id="wave-input"
                           value={wave}
                           onChange={setWave}
                           type="number"
                    />
                </Column>
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary"
                            size="medium"
                            onClick={onClickConfirm}>
                     <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default AddTrafficLightDeviceModal;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/trafficlightdevice/modal/AddTrafficLightDeviceModal.js